import ApiManager from '../../utils/ApiManager'
import _ from 'lodash'
import Constants from '../../utils/Constants'

const state = {
  initLoaded: false,
  list: {
    loading: false,
    rowsPerPage: 100,
    totalItems: 0,
    items: []
  },
  current_condition_jp: null,
  current_page: 1,
  current_search_condition: {},
  user_list: [],
  message: ''
}

const actions = {
  /**
   * 分析履歴一覧データ取得
   */
  async getHistoryList ({ state, commit },
    { pageNo, sortField, sortType, userId, analyzeTargetCode, publishSetting, analyzeType, analyzeTermFrom, analyzeTermTo, readStatus }) {
    commit('setListLoading', true)
    const response = await ApiManager.request('History').historyList(
      pageNo,
      state.list.rowsPerPage,
      sortField,
      sortType,
      null,
      userId,
      analyzeTargetCode,
      publishSetting,
      analyzeType,
      analyzeTermFrom,
      analyzeTermTo,
      readStatus
    )
    commit('setCurrentPage', pageNo)
    commit('setCurrentSearchCondition', {
      userId: userId,
      analyzeTargetCode: analyzeTargetCode,
      publishSetting: publishSetting,
      analyzeType: analyzeType,
      analyzeTermFrom: analyzeTermFrom,
      analyzeTermTo: analyzeTermTo,
      readStatus: readStatus
    })
    commit('setList', response ? response.data : null)
  },
  async doUpdate ({ state, commit }, editData) {
    commit('setListLoading', true)
    const response = await ApiManager.request('History').historyEdit(
      {
        id: editData.id,
        publish_setting: parseInt(editData.publishSetting),
        memo: editData.memo
      }
    )
    if (response.data.code === 200000) {
      commit('afterUpdated', response.data.data)
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  async doDelete ({ state, commit }, deleteIds) {
    commit('setListLoading', true)
    const response = await ApiManager.request('History').historyDelete(deleteIds)
    if (response.data.code === 200000) {
      commit('afterDeleted', deleteIds)
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  async getDetail ({ state, commit }, historyId) {
    this.dispatch('loading/loadingPagePlus')
    //  分析履歴から読み込み
    const resHistory = await ApiManager.request('History').historyDetail(historyId)
    if (resHistory.data.code === 200000) {
      commit('setCurrentConditionjp', resHistory.data.data.condition_jp)
      this.dispatch('loading/loadingPageMinus')
    } else {
      commit('setCurrentConditionjp', null)
      commit('setMessage', resHistory.data.data)
      this.dispatch('loading/loadingPageMinus')
    }
  },
  async getUserList ({ state, commit }) {
    const response = await ApiManager.request('History').historyUserList()
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      let userList = [{ 'id': '', 'user_name': 'ユーザを選択' }].concat(response.data.data)
      commit('setUserList', userList)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      commit('setUserList', [])
    }
  }
}

const mutations = {
  init (state, data) {
    // 初期ローディングの終了
    state.initLoaded = true
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.list.loading = data
    this.dispatch('loading/loadingPagePlus')
  },
  setList (state, data) {
    if (data) {
      state.list.items = data.data
      state.list.totalItems = data.meta.count
    } else {
      state.list.items = []
      state.list.totalItems = 0
    }
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  setCurrentPage (state, data) {
    state.current_page = data
  },
  setCurrentSearchCondition (state, data) {
    state.current_search_condition = data
  },
  setCurrentConditionjp (state, data) {
    state.current_condition_jp = data
  },
  setMessage (state, data) {
    state.message = data.message
  },
  afterUpdated (state, data) {
    let index = _.findIndex(state.list.items, function (o) { return o.id === data.id })
    let history = state.list.items[index]
    let memo = data.memo
    history.origin_memo = memo
    const bytesToSize = (bytes) => {
      if (!bytes) {
        return '0GB'
      }
      return parseFloat((bytes / Math.pow(1024, 3)).toFixed(2)) + 'GB'
    }
    if (data.analyze_error && data.analyze_error.startsWith('EEA0004:Download file size exceeded:')) {
      memo += `@SPLITTER@<span style="color: red;">条件を絞り込んで再実行してください(${bytesToSize(data.analyze_error.substr(36))})`
    }
    history.memo = memo
    history.publish_setting = (data.publish_setting === 1 ? 'Public' : 'Private')
    state.list.items[index] = history
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  afterDeleted (state, data) {
    this.dispatch('loading/loadingPageMinus')
    this.dispatch('pagehistorylist/getHistoryList', {
      pageNo: state.current_page,
      sortField: null,
      sortType: null,
      userId: state.current_search_condition.userId,
      analyzeTargetCode: state.current_search_condition.analyzeTargetCode,
      publishSetting: state.current_search_condition.publishSetting,
      analyzeType: state.current_search_condition.analyzeType,
      analyzeTermFrom: state.current_search_condition.analyzeTermFrom,
      analyzeTermTo: state.current_search_condition.analyzeTermTo,
      readStatus: state.current_search_condition.readStatus
    })
  },
  setUserList (state, data) {
    state.user_list = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
